import { render, staticRenderFns } from "./TaskAddedTags.vue?vue&type=template&id=6901f02e&scoped=true"
import script from "./TaskAddedTags.vue?vue&type=script&lang=js"
export * from "./TaskAddedTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6901f02e",
  null
  
)

export default component.exports